<template>
<div class="locale-changer text_all">
  <div class="locale">
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="language">
        <path
          id="Vector"
          d="M19.17 8.5L20.0394 8.5L19.6022 7.74855C18.5829 5.99675 16.9581 4.63672 15.002 3.96696L13.792 3.55268L14.4001 4.67776C14.9794 5.74935 15.425 6.9108 15.7356 8.124L15.8319 8.5L16.22 8.5L19.17 8.5ZM12.6612 3.75557L12.25 3.16104L11.8388 3.75557C10.9799 4.99739 10.3066 6.37461 9.86118 7.85602L9.66753 8.5L10.34 8.5L14.16 8.5L14.8325 8.5L14.6388 7.85602C14.1934 6.37461 13.5201 4.99739 12.6612 3.75557ZM4.02493 14.1213L4.11961 14.5L4.51 14.5L7.89 14.5L8.45427 14.5L8.38637 13.9398C8.30746 13.2888 8.25 12.6512 8.25 12C8.25 11.3488 8.30746 10.7112 8.38637 10.0602L8.45427 9.5L7.89 9.5L4.51 9.5L4.11961 9.5L4.02493 9.87873C3.85698 10.5505 3.75 11.2617 3.75 12C3.75 12.7383 3.85698 13.4495 4.02493 14.1213ZM5.33 15.5L4.46325 15.5L4.89717 16.2503C5.91719 18.0141 7.54303 19.3637 9.49803 20.033L10.708 20.4473L10.0999 19.3222C9.52061 18.2506 9.07496 17.0892 8.76438 15.876L8.66812 15.5L8.28 15.5L5.33 15.5ZM8.28 8.5L8.66812 8.5L8.76438 8.124C9.07496 6.9108 9.52061 5.74935 10.0999 4.67776L10.708 3.55268L9.49803 3.96696C7.54303 4.63633 5.91719 5.9859 4.89717 7.74969L4.46325 8.5L5.33 8.5L8.28 8.5ZM11.8388 20.2444L12.25 20.839L12.6612 20.2444C13.5201 19.0026 14.1934 17.6254 14.6388 16.144L14.8325 15.5L14.16 15.5L10.34 15.5L9.66753 15.5L9.86118 16.144C10.3066 17.6254 10.9799 19.0026 11.8388 20.2444ZM14.59 14.5L15.0264 14.5L15.0854 14.0676C15.1766 13.3991 15.25 12.7133 15.25 12C15.25 11.287 15.1767 10.5914 15.0853 9.93142L15.0255 9.5L14.59 9.5L9.91 9.5L9.47446 9.5L9.41472 9.93142C9.32334 10.5914 9.25 11.287 9.25 12C9.25 12.7133 9.32343 13.3991 9.41458 14.0676L9.47355 14.5L9.91 14.5L14.59 14.5ZM14.4001 19.3222L13.792 20.4473L15.002 20.033C16.9581 19.3633 18.5829 18.0032 19.6022 16.2514L20.0394 15.5L19.17 15.5L16.22 15.5L15.8319 15.5L15.7356 15.876C15.425 17.0892 14.9794 18.2506 14.4001 19.3222ZM16.1136 13.9398L16.0457 14.5L16.61 14.5L19.99 14.5L20.3804 14.5L20.4751 14.1213C20.643 13.4495 20.75 12.7383 20.75 12C20.75 11.2617 20.643 10.5505 20.4751 9.87873L20.3804 9.5L19.99 9.5L16.61 9.5L16.0457 9.5L16.1136 10.0602C16.1925 10.7112 16.25 11.3488 16.25 12C16.25 12.6512 16.1925 13.2888 16.1136 13.9398ZM2.75 12C2.75 6.75549 6.99679 2.5 12.24 2.5C17.4942 2.5 21.75 6.75647 21.75 12C21.75 17.2435 17.4942 21.5 12.24 21.5C6.99679 21.5 2.75 17.2445 2.75 12Z"
          fill="#222222"
          stroke="#222222"
        />
      </g>
    </svg>
  </div>
  <select v-model="language" class="locale-select" @change="changeLanguage($event)">
    <option v-for="(lang, key) in supportedLanguages" :key="`Lang${key}`" :value="key">
      {{ lang }}
    </option>
  </select>
</div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import supportedLanguages, { resolveLocale } from "../utils/language.js";
import { inject, onMounted, ref } from "vue";

const { locale } = useI18n();
const language = ref("en");
const brandingTheme = inject("brandingTheme");

const setLocale = (lang) => {
  locale.value = lang;
  language.value = lang;
};

onMounted(() => {
  setLocale(resolveLocale(brandingTheme.value?.forceDefaultLanguage));
});

const changeLanguage = (e) => {
  locale.value = e.target.value;
};
</script>

<style>
.locale-changer {
  position: relative;
}

.locale {
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-size: 16px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0em;
  text-align: left;
}

#language path {
  fill: var(--text);
  stroke: var(--text);
}

.locale-select {
  position: absolute;
  top: 0;
  right: 0;
  height: 24px;
  margin-right: 10px;
  border: none;
  opacity: 0;
}

html[dir="rtl"] .text_all .locale-select {
  left: 0;
  margin-right: 0;
  margin-left: 10px;
}
</style>
